import { type RefAttributes } from "react"
import {
    Card,
    CardBody,
    CardHeader,
    type CardHeaderProps,
    type CardProps,
    Container,
    type ContainerProps,
    Stack,
    type StackProps,
    Typography,
    type TypographyProps,
} from "@octopus-energy/coral/atoms"

export const SubscriptionContainer = {
    Form({
        responsive = true,
        containerProps,
        cardProps: globalCardProps,
        ...props
    }: StackProps & { responsive?: boolean } & {
        containerProps?: ContainerProps & RefAttributes<HTMLDivElement>
    } & {
        cardProps?: CardProps & { title?: CardHeaderProps["title"] }
    }) {
        const { title, ...cardProps } = globalCardProps ?? {}

        return (
            <Container
                paddingX={{ base: "md", sm: "lg" }}
                theme={{ base: responsive ? "base900" : "none", md: "none" }}
                {...containerProps}
            >
                <Card
                    padding="none"
                    borderless={responsive ? { base: true, md: false } : false}
                    {...cardProps}
                >
                    {title && <CardHeader>{title}</CardHeader>}
                    <CardBody>
                        <Container
                            paddingY="lg"
                            paddingX={{ base: responsive ? "none" : "lg", md: "lg" }}
                        >
                            <Stack
                                flexDirection="column"
                                gap="lg"
                                {...props}
                            />
                        </Container>
                    </CardBody>
                </Card>
            </Container>
        )
    },

    Section(props: StackProps) {
        return (
            <Container paddingX={{ base: "md", sm: "lg" }}>
                <Stack
                    flexDirection="column"
                    gap="lg"
                    {...props}
                />
            </Container>
        )
    },

    StepTitle(props: TypographyProps) {
        return (
            <Typography
                textAlign="center"
                textStyle="h3"
                component="h1"
                {...props}
            />
        )
    },

    StepNumber(props: TypographyProps) {
        return (
            <Typography
                textAlign="center"
                textStyle="h5"
                component="h2"
                color="tertiary500"
                {...props}
            />
        )
    },
}
